import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import survey from './modules/survey';
import square from './modules/square';
import library from './modules/library';
import common from './modules/common';
import travel from './modules/travel';
import realtalk from './modules/realtalk';
import purchase from './modules/purchase';
import coin from './modules/coin';
import main from './modules/main';
import unit from './modules/unit';
import solution from './modules/solution';
import member from './modules/member';
import faq from './modules/faq';
import order from './modules/order';
import ticket from './modules/ticket';
import badge from './modules/badge';
import remote from "@/store/modules/remote";
import goods from './modules/goods';
import memberJoin from "./modules/memberJoin";
import rank from "./modules/rank";
import notice from "./modules/notice";
import coupon from "./modules/coupon";
import push from '@/store/modules/push'
import popup from "@/store/modules/popup";
import client from "@/store/modules/client";
import trial from "@/store/modules/trial";
import certify from "@/store/modules/certify";
import messeage from "@/store/modules/message";
import mission from "@/store/modules/mission";
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        // auth: auth
    },

    mutations: {
    },

    actions: {
    },
    modules: {
        auth,
        badge,
        common,
        faq,
        library,
        member,
        square,
        survey,
        travel,
        realtalk,
        purchase,
        coin,
        main,
        unit,
        solution,
        order,
        ticket,
        goods,
        remote,
        memberJoin,
        rank,
        notice,
        coupon,
        push,
        popup,
        client,
        trial,
        certify,
        messeage,
        mission
    },
});
